import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex justify-between mb-4 flex-col sm:flex-row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Fill schedule from templates", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Save schedule", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 2,
  class: "flex flex-col"
}
const _hoisted_7 = { class: "overflow-x-auto" }
const _hoisted_8 = { class: "align-middle inline-block min-w-full" }
const _hoisted_9 = { class: "border border-b border-gray-200 rounded-md" }
const _hoisted_10 = { class: "table-fixed min-w-full divide-y divide-gray-200" }
const _hoisted_11 = { class: "bg-gray-50" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
}, " Contract ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", { class: "px-1 py-3 text-center text-xs font-medium text-gray-500 border-r" }, "Fill", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", {
  width: "150px",
  style: {"min-width":"150px"},
  class: "px-1 py-3 text-center text-xs font-medium text-gray-500 border-r"
}, "Sum", -1)
const _hoisted_15 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_16 = { class: "px-2 py-3 whitespace-nowrap border-r" }
const _hoisted_17 = { class: "flex align-middle justify-between items-center" }
const _hoisted_18 = { class: "text-sm" }
const _hoisted_19 = { class: "px-2 py-1" }
const _hoisted_20 = { class: "mx-2 text-xs font-semibold text-center p-1 uppercase rounded-md text-indigo-600 bg-indigo-100" }
const _hoisted_21 = { class: "px-3 py-3 whitespace-nowrap text-center text-sm font-medium border-r" }
const _hoisted_22 = { class: "px-3 py-3 whitespace-nowrap text-center text-sm font-medium border-r" }
const _hoisted_23 = {
  key: 0,
  class: "text-xs font-semibold text-center p-1 rounded-md text-green-600 bg-green-100 border border-green-300"
}
const _hoisted_24 = {
  key: 1,
  class: "flex"
}
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "inline-flex items-center px-1 border border-r-0 border-l-0 border-gray-200 bg-gray-50 text-gray-500 text-sm" }, "h", -1)
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "inline-flex items-center px-1 border rounded-r-md border-gray-200 bg-gray-50 text-gray-500 text-sm" }, "m", -1)
const _hoisted_29 = { key: 0 }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 0,
  class: "relative"
}
const _hoisted_32 = { class: "absolute w-44 overflow-hidden top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-2xl rounded-md p-1 bg-gray-100 border border-gray-300" }
const _hoisted_33 = { class: "text-center text-xs font-semibold mb-1" }
const _hoisted_34 = { class: "flex justify-center items-stretch mb-1" }
const _hoisted_35 = { class: "flex" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "inline-flex items-center px-1 border border-r-0 border-l-0 border-gray-200 bg-gray-50 text-gray-500 text-sm" }, "h", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "inline-flex items-center px-1 border rounded-r-none border-gray-200 bg-gray-50 text-gray-500 text-sm" }, "m", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TemplateIcon = _resolveComponent("TemplateIcon")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_XIcon = _resolveComponent("XIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_app_button, {
        onClick: _ctx.onClickSetAllContractsTemplateTime,
        type: "green",
        class: "mb-2 sm:mb-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TemplateIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_app_button, {
        onClick: _ctx.onClickSave,
        type: "blue"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_CheckIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Loading "))
      : (_ctx.contracts.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " No contracts to show. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("table", _hoisted_10, [
                    _createElementVNode("thead", _hoisted_11, [
                      _createElementVNode("tr", null, [
                        _hoisted_12,
                        _hoisted_13,
                        _hoisted_14,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day, index) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: day.date,
                            class: _normalizeClass(["text-center text-xs font-medium text-gray-500 uppercase", _ctx.getDateBgClass(day)])
                          }, _toDisplayString(index + 1), 3))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("tbody", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contracts, (contract) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: contract.id,
                          class: "hover:bg-gray-50"
                        }, [
                          _createElementVNode("td", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("span", _hoisted_18, [
                                _createElementVNode("span", _hoisted_19, _toDisplayString(contract.person.surname) + " " + _toDisplayString(contract.person.name), 1)
                              ]),
                              _createElementVNode("span", _hoisted_20, _toDisplayString(contract.contractType.id), 1)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_21, [
                            _createVNode(_component_app_button, {
                              onClick: ($event: any) => (_ctx.onClickSetContractTemplateTime(contract.id)),
                              type: "green",
                              style: {"padding-left":"0.5rem","padding-right":"0.5rem"},
                              title: "Fill schedule from template"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_TemplateIcon, { class: "h-5 w-5" })
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _createElementVNode("td", _hoisted_22, [
                            (_ctx.isContractOfDaysType(contract.id))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.formatTime(_ctx.getContractTimeSum(contract.id))), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.schedule.get(contract.id).sum.hours) = $event),
                                    type: "text",
                                    inputmode: "numeric",
                                    onFocus: _cache[0] || (_cache[0] = ($event: any) => ($event.target.select())),
                                    class: "w-full rounded-l-md border-gray-200 text-sm text-gray-700 px-1 text-center"
                                  }, null, 40, _hoisted_25), [
                                    [
                                      _vModelText,
                                      _ctx.schedule.get(contract.id).sum.hours,
                                      void 0,
                                      { number: true }
                                    ]
                                  ]),
                                  _hoisted_26,
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.schedule.get(contract.id).sum.minutes) = $event),
                                    ref_for: true,
                                    ref: "minutes",
                                    type: "text",
                                    inputmode: "numeric",
                                    onFocus: _cache[1] || (_cache[1] = ($event: any) => ($event.target.select())),
                                    class: "w-full border-gray-200 border-r-0 text-sm text-gray-700 px-1 text-center"
                                  }, null, 40, _hoisted_27), [
                                    [
                                      _vModelText,
                                      _ctx.schedule.get(contract.id).sum.minutes,
                                      void 0,
                                      { number: true }
                                    ]
                                  ]),
                                  _hoisted_28
                                ]))
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: day.date,
                              class: _normalizeClass(["text-center", _ctx.getDateBgClass(day)])
                            }, [
                              (_ctx.isContractOfDaysType(contract.id))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                    _createElementVNode("button", {
                                      onClick: ($event: any) => (_ctx.onOpenTimeDialogue(contract.id, day.date)),
                                      class: _normalizeClass(["mx-2 text-xs font-semibold text-center p-1 rounded-md", [_ctx.getTimeMinutes(contract.id, day.date) > 0 ? 'text-green-600 bg-green-100' : 'text-gray-600 bg-gray-100']])
                                    }, _toDisplayString(_ctx.getTime(contract.id, day.date)), 11, _hoisted_30),
                                    (_ctx.activeTimeDialogue.contractID == contract.id && _ctx.activeTimeDialogue.date == day.date)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                          _createElementVNode("div", _hoisted_32, [
                                            _createElementVNode("div", _hoisted_33, [
                                              _createElementVNode("div", null, _toDisplayString(contract.person.surname) + " " + _toDisplayString(contract.person.name), 1),
                                              _createElementVNode("div", null, _toDisplayString((new Date(day.date)).getDate()) + ". " + _toDisplayString(_ctx.month.name), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_34, [
                                              _createVNode(_component_app_button, {
                                                onClick: ($event: any) => (_ctx.onClickSetTemplateTime(contract.id, day.date)),
                                                type: "green",
                                                class: "flex-1 rounded-r-none",
                                                title: "Use template time"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_TemplateIcon, { class: "h-5 w-5" })
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]),
                                              _createVNode(_component_app_button, {
                                                onClick: ($event: any) => (_ctx.onClickRemoveTime(contract.id, day.date)),
                                                type: "red",
                                                class: "flex-1 rounded-l-none",
                                                title: "Remove date"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_XIcon, { class: "h-5 w-5" })
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"])
                                            ]),
                                            _createElementVNode("div", _hoisted_35, [
                                              _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeTimeDialogue.hours) = $event)),
                                                type: "text",
                                                inputmode: "numeric",
                                                onFocus: _cache[3] || (_cache[3] = ($event: any) => ($event.target.select())),
                                                class: "w-full rounded-l-md border-gray-200 text-sm text-gray-700 px-1 text-center"
                                              }, null, 544), [
                                                [
                                                  _vModelText,
                                                  _ctx.activeTimeDialogue.hours,
                                                  void 0,
                                                  { number: true }
                                                ]
                                              ]),
                                              _hoisted_36,
                                              _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.activeTimeDialogue.minutes) = $event)),
                                                type: "text",
                                                inputmode: "numeric",
                                                onFocus: _cache[5] || (_cache[5] = ($event: any) => ($event.target.select())),
                                                class: "w-full border-gray-200 border-r-0 text-sm text-gray-700 px-1 text-center"
                                              }, null, 544), [
                                                [
                                                  _vModelText,
                                                  _ctx.activeTimeDialogue.minutes,
                                                  void 0,
                                                  { number: true }
                                                ]
                                              ]),
                                              _hoisted_37,
                                              _createVNode(_component_app_button, {
                                                onClick: ($event: any) => (_ctx.onClickSetTime(contract.id, day.date)),
                                                type: "blue",
                                                class: "rounded-l-none",
                                                style: {"padding-left":"0.5rem","padding-right":"0.5rem"},
                                                title: "Set selected time"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_CheckIcon, { class: "h-5 w-5" })
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"])
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ]))
  ], 64))
}